import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  Dimmer, Container, Grid, Card, Form,
} from 'tabler-react';
import ReactModal from 'react-modal';
import ItemTable from '../components/ItemTable';
import Scanner from './index';

const allItems = gql`
query searchArchive($offset: Int, $conditions: [String], $ended: Boolean, $term: String!, $locations: [String], $sort: ARCHIVE_SORT, $newerThan: String, $olderThan: String) {
  searchArchive(offset: $offset, term: $term, locations: $locations, ended: $ended, conditions: $conditions, sort: $sort, olderThan: $olderThan, newerThan: $newerThan) {
    nextOffset
    totalCount
    items {
      imageUrl
      id
      ended
      endsAt
      searchDescription
      descriptionData {
        condition
        description
        raw
      }
      location
      highBidderId
      lastHighBid
      itemUrl
    }
    nextOffset
    stats {
      averagePrice
      count
    }
  }
}
`;


class Search extends Component {
  state = {
    term: '',
    searchTerm: '',
    sort: 'DATE_DESC',
    offset: 0,
    lastOffset: 0,
    showModal: false,
    currentItem: null,
  }

  searchWindowRef = React.createRef()

  handleSortChange = ({ target: { value } }) => {
    this.setState({ sort: value, offset: 0 });
  }

  nextPage = ({ nextOffset }) => {
    this.setState({ lastOffset: this.state.offset, offset: nextOffset });
  }

  prevPage = ({ nextOffset }) => {
    this.setState({
      lastOffset: Math.max(0, this.state.lastOffset - (nextOffset - this.state.offset)),
      offset: Math.max(0, this.state.lastOffset),
    });
  }


  handleItemClick = (currentItem) => {
    this.setState({ currentItem, showModal: true });
  }

  renderModal = () => {
    const { currentItem } = this.state;
    const hasItem = !!currentItem;
    const hasRaw = hasItem && currentItem.descriptionData && currentItem.descriptionData.raw;

    let data = {};

    if (!hasItem) return null;

    if (hasRaw) {
      data = { ...JSON.parse(this.state.currentItem.descriptionData.raw), 'Search Description': currentItem.searchDescription };
    } else if (hasItem) {
      data = { 'Search Description': currentItem.searchDescription };
    }

    const url = currentItem.itemUrl.replace('beta', 'www');

    return (
      <ReactModal
        isOpen={this.state.showModal}
        contentLabel="Minimal Modal Example"
        overlayClassName="modal-backdrop fade show"
        bodyOpenClassName="modal-open"
        className="modal fade show"
      >

        <div className="modal-dialog modal-lg" role="document">
          <Card className="modal-content">
            <Card.Header>
              <Card.Title>Item Details</Card.Title>
              <Card.Options>
                <Card.OptionsItem type="close" onClick={() => this.setState({ showModal: false })} />
              </Card.Options>
            </Card.Header>
            <Card.Body>
              <dl className="row">
                {Object.keys(data).filter(key => data[key] != null && data[key] !== '').map(key => (
                  <React.Fragment>
                    <dt className="col-sm-3">{key}</dt>
                    <dd className="col-sm-9">{data[key]}</dd>
                  </React.Fragment>
                ))}
              </dl>
              <a about="_blank" href={url}>{url}</a>
            </Card.Body>
          </Card>
        </div>

      </ReactModal>
    );
  }

  handleCodeScan = ({ codeResult: { code } }) => {
    window.scrollTo(0, this.searchWindowRef.current.offsetTop);
    const term = `${code}`;
    this.setState({ term, searchTerm: term });
  }

  handleSetTerm = (term) => {
    this.setState({ term, searchTerm: term });
  }

  render() {
    const {
      sort, currentColumns, searchTerm, offset, term,
    } = this.state;

    return (
      <Container>
        {this.renderModal()}
        <Grid.Row className="mt-3">
          <Grid.Col lg={12}>
            <Card>
              <Scanner onDetected={this.handleCodeScan} />
            </Card>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col lg={12}>
            <Form.Group className="">
              <Form.Input
                icon="search"
                placeholder="Search for..."
                position="append"
                onChange={({ target: { value } }) => this.handleSetTerm(value)}
                value={term}
              />
            </Form.Group>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col lg={12}>
            <div ref={this.searchWindowRef}>
              <Card>
                <Query
                  query={allItems}
                  variables={{
                    term: searchTerm,
                    offset,
                    sort,
                  }}
                  fetchPolicy="network-only"
                >
                  {({
                    loading, error, data,
                  }) => {
                    if (error) {
                      return error.toString();
                    }
                    const anyItems = data.searchArchive && data.searchArchive.items;
                    if (loading && !anyItems) {
                      return (
                        <Card.Body>
                          <Dimmer active loader />
                        </Card.Body>
                      );
                    }
                    const { items, stats, nextOffset } = data.searchArchive;
                    return (
                      <ItemTable
                        nextPage={() => this.nextPage({ nextOffset })}
                        prevPage={() => this.prevPage({ nextOffset })}
                        stats={stats}
                        items={items}
                        firstPage={offset === 0}
                        lastPage={items.length < 40}
                        onClick={this.handleItemClick}
                        currentColumns={currentColumns}
                        handleColumnChange={this.handleColumnChange}
                      />
                    );
                  }}
                </Query>
              </Card>
            </div>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/scanner/scanPage.js